import React from "react";
import { StyleSheet, Text, TouchableOpacity, View, Linking } from "react-native";
import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import { StripeInvoice } from "@/services/stripePaymentServices";

interface InvoiceCardProps {
  invoice: StripeInvoice;
}

const formatInvoiceDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const formatAmount = (amount: number) => {
  return `$${(amount / 100).toFixed(2)}`;
};

const getStatusStyle = (status: string) => {
  if (status === "paid") {
    return {
      container: styles.statusPaid,
      text: styles.statusPaidText,
    };
  }
  return {
    container: styles.statusFailed,
    text: styles.statusFailedText,
  };
};

const InvoiceCard: React.FC<InvoiceCardProps> = ({ invoice }) => {
  const statusStyle = getStatusStyle(invoice.status || "");

  const handlePress = () => {
    if (invoice.hostedInvoiceUrl) {
      Linking.openURL(invoice.hostedInvoiceUrl);
    }
  };

  return (
    <TouchableOpacity style={styles.container} onPress={handlePress}>
      <View style={styles.left}>
        <Text style={styles.date}>{formatInvoiceDate(invoice.date)}</Text>
        <Text style={styles.amount}>
          {formatAmount(invoice.amount)}
        </Text>
      </View>
      <View style={[styles.statusBadge, statusStyle.container]}>
        <Text style={statusStyle.text}>
          {invoice.status === "paid" ? "Paid" : invoice.status}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default InvoiceCard;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  left: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
  },
  date: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "rgba(22, 29, 20, 0.7)",
  },
  amount: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "rgba(22, 29, 20, 0.7)",
  },
  statusBadge: {
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  statusPaid: {
    backgroundColor: "#E1EFE4",
    borderWidth: 1,
    borderColor: "rgba(15, 145, 41, 0.2)",
  },
  statusPaidText: {
    fontSize: 13,
    fontFamily: FontFamilies.Inter.Regular,
    color: Colors.primary,
  },
  statusFailed: {
    backgroundColor: "#FDE7D1",
    borderWidth: 1,
    borderColor: "#C12915",
  },
  statusFailedText: {
    fontSize: 13,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#C12915",
  },
});
